export default __webpack_public_path__ + "static/media/bg-5.dff62050.jpg";